import { updateField } from 'vuex-map-fields'
import Vue from 'vue'

function getBaselineSmallStats(payload, type) {
  const reviewDashboard = (payload || []).find(item => item.type === type)
  return reviewDashboard && Array.isArray(reviewDashboard.smallStats) ? reviewDashboard.smallStats : []
}

const SET_DASHBOARD = (state, payload) => {
  state.dashboardData = payload
}

const SET_DASHBOARD_PROJECTS = (state, payload) => {
  state.dashboardProjects = payload
}

const SET_DASHBOARD_PROJECTS_CODING = (state, payload) => {
  state.codingDashboardProjects = payload
}

const SET_REVIEW_DASHBOARD = (state, payload) => {
  state.reviewDashboardData = payload
  state.reviewDashboardBaselineSmallStatsIP = getBaselineSmallStats(payload, 'inpatient')
  state.reviewDashboardBaselineSmallStatsOP = getBaselineSmallStats(payload, 'outpatient')
  state.reviewDashboardBaselineSmallStatsAMB = getBaselineSmallStats(payload, 'ambulatory')
  state.reviewDashboardBaselineSmallStatsPRO = getBaselineSmallStats(payload, 'profee')
}

const SET_IP_REVIEW_DASHBOARD = (state, payload) => {
  const index = state.reviewDashboardData.findIndex(x => x.description === 'Inpatient Review')
  Vue.set(state.reviewDashboardData, index, payload)
}

const SET_OP_REVIEW_DASHBOARD = (state, payload) => {
  const index = state.reviewDashboardData.findIndex(x => x.description === 'Outpatient Review')
  Vue.set(state.reviewDashboardData, index, payload)
}

const SET_AMB_REVIEW_DASHBOARD = (state, payload) => {
  const index = state.reviewDashboardData.findIndex(x => x.description === 'Ambulatory Review')
  Vue.set(state.reviewDashboardData, index, payload)
}

const SET_PRO_REVIEW_DASHBOARD = (state, payload) => {
  const index = state.reviewDashboardData.findIndex(x => x.description === 'Profee Review')
  Vue.set(state.reviewDashboardData, index, payload)
}

const SET_SELECTED_PROJECTS = (state, payload) => {
  state.selectedProjects = payload
}

const CLEAR_REVIEW_DASHBOARD_FILTERS = (state, payload) => {
  state.inpatientStickyGroupingFilters = []
  state.outpatientStickyGroupingFilters = []
  state.ambulatoryStickyGroupingFilters = []
  state.proStickyGroupingFilters = []
}

const CLEAR_REVIEW_DASHBOARD = (state, payload) => {
  state.selectedProjects = []
  state.dashboardProjects = []
  state.reviewDashboardData = []
  state.reviewDashboardBaselineSmallStatsIP = []
  state.reviewDashboardBaselineSmallStatsOP = []
  state.reviewDashboardBaselineSmallStatsAMB = []
  state.reviewDashboardBaselineSmallStatsPRO = []
  state.inpatientStickyGroupingFilters = []
  state.outpatientStickyGroupingFilters = []
  state.ambulatoryStickyGroupingFilters = []
  state.proStickyGroupingFilters = []
}

const SET_DASHBOARD_ACCOUNTS = (state, payload) => {
  state.dashboardAccounts = payload
}

const CLEAR_DASHBOARD_ACCOUNTS = (state, payload) => {
  state.dashboardAccounts = []
}

const SET_WORKSHEET = (state, payload) => {
  state.worksheet = payload
}

const SET_SCHEDULE = (state, payload) => {
  state.schedule = payload
}

const SET_CALEDNAR_SCHEDULE = (state, payload) => {
  state.calendarSchedule = payload
}

const CLEAR_CALEDNAR_SCHEDULE = (state, payload) => {
  state.calendarSchedule = []
}

const SET_CODINGLOGLIST = (state, payload) => {
  state.codingLogs = payload
}

const SET_CODINGLOG = (state, payload) => {
  state.codingLog = payload
}

const SET_DASHBOARD_COMPARISON_ACCOUNTS = (state, payload) => {
  // state.comparisonAccounts = payload
  let filtered = state.comparisonAccounts.filter(x => x.type === 'inpatient bedsize review')
  filtered = filtered.concat(payload)
  state.comparisonAccounts = filtered
}

const SET_DASHBOARD_COMPARISON_ACCOUNTS_BEDSIZE = (state, payload) => {
  let filtered = state.comparisonAccounts.filter(x => x.type === 'inpatient all review')
  filtered = filtered.concat(payload)
  state.comparisonAccounts = filtered
}

const SET_DASHBOARD_COMPARISON_ACCOUNTS_OP = (state, payload) => {
  let filtered = state.comparisonAccountsOP.filter(x => x.type === 'outpatient bedsize review')
  filtered = filtered.concat(payload)
  state.comparisonAccountsOP = filtered
}

const SET_DASHBOARD_COMPARISON_ACCOUNTS_OP_BEDSIZE = (state, payload) => {
  let filtered = state.comparisonAccountsOP.filter(x => x.type === 'outpatient all review')
  filtered = filtered.concat(payload)
  state.comparisonAccountsOP = filtered
}

const SET_DASHBOARD_COMPARISON_ACCOUNTS_AMB = (state, payload) => {
  let filtered = state.comparisonAccountsAMB.filter(x => x.type === 'ambulatory bedsize review')
  filtered = filtered.concat(payload)
  state.comparisonAccountsAMB = filtered
}

const SET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_BEDSIZE = (state, payload) => {
  let filtered = state.comparisonAccountsAMB.filter(x => x.type === 'ambulatory all review')
  filtered = filtered.concat(payload)
  state.comparisonAccountsAMB = filtered
}

const SET_DASHBOARD_COMPARISON_ACCOUNTS_PRO = (state, payload) => {
  state.comparisonAccountsPRO = payload
}

const SET_QUERY_LIST_FIELDS = (state, payload) => {
  state.queryDrillDown = payload.queryDrillDown
  state.queryGrouping = payload.queryGrouping
}

const SET_PENDING_LIST_FIELDS = (state, payload) => {
  state.pendingDrillDown = payload.pendingDrillDown
  state.pendingGrouping = payload.pendingGrouping
}

const SET_CODING_DATE_RANGE = (state, payload) => {
  state.codingDateRange = payload
}

const SET_CURRENTLY_PENDING = (state, payload) => {
  state.currentlyPending = payload
}

const SET_PENDINGLIST_STATISTICS = (state, payload) => {
  let dashboardData = state.dashboardData[0] ? state.dashboardData[0] : {}
  dashboardData.largeStats[10].data = payload.item1
  dashboardData.largeStats[11].data = payload.item2
  dashboardData.largeStats[12].data = payload.item3
  dashboardData.largeStats[13].data = payload.item4
  dashboardData.largeStats[14].data = payload.item5
}

const SET_DX_MODAL_DATA = (state, payload) => {
  state.dxModalData = payload
}

export default {
  updateField,
  SET_DASHBOARD,
  SET_CURRENTLY_PENDING,
  SET_PENDINGLIST_STATISTICS,
  SET_CODING_DATE_RANGE,
  SET_DASHBOARD_PROJECTS,
  SET_DASHBOARD_PROJECTS_CODING,
  SET_REVIEW_DASHBOARD,
  SET_SELECTED_PROJECTS,
  CLEAR_REVIEW_DASHBOARD_FILTERS,
  CLEAR_REVIEW_DASHBOARD,
  SET_DASHBOARD_ACCOUNTS,
  CLEAR_DASHBOARD_ACCOUNTS,
  SET_WORKSHEET,
  SET_SCHEDULE,
  SET_CODINGLOGLIST,
  SET_CODINGLOG,
  SET_DASHBOARD_COMPARISON_ACCOUNTS,
  SET_DASHBOARD_COMPARISON_ACCOUNTS_BEDSIZE,
  SET_DASHBOARD_COMPARISON_ACCOUNTS_OP,
  SET_DASHBOARD_COMPARISON_ACCOUNTS_OP_BEDSIZE,
  SET_DASHBOARD_COMPARISON_ACCOUNTS_PRO,
  SET_CALEDNAR_SCHEDULE,
  CLEAR_CALEDNAR_SCHEDULE,
  SET_QUERY_LIST_FIELDS,
  SET_PENDING_LIST_FIELDS,
  SET_IP_REVIEW_DASHBOARD,
  SET_OP_REVIEW_DASHBOARD,
  SET_PRO_REVIEW_DASHBOARD,
  SET_AMB_REVIEW_DASHBOARD,
  SET_DASHBOARD_COMPARISON_ACCOUNTS_AMB,
  SET_DASHBOARD_COMPARISON_ACCOUNTS_AMB_BEDSIZE,
  SET_DX_MODAL_DATA
}
